import fa from "../../assets/locales/fa/translation.json";

const resources = {
  fa: fa,
};

const t = text => {
  const selectedResource = resources["fa"];
  return selectedResource[text] ? selectedResource[text] : text;
};

export default t;
